export var FACELIFTDEF = {
    name: "facelift",
    vname: "LBL_FACELIFT",
    type: "facelift",
    reportable: false,
    source: "non-db",
    duplicate_merge: "disabled",
    comment: "facelift data for module",
    inline_edit: false,
};
